module.exports = __webpack_public_path__ + "img/Disaster-4.5a517a42.jpg";